@if (contentForm()) {
  <section>
    <fin-form-fields>
      @if (content().teaserTitle) {
        <h3 class="content-switcher-title font-headline-small">
          {{ content().teaserTitle }}
        </h3>
      }
      <div class="dropdown-container pr-large-b bold-type">
        <fin-simple-select-field
          class="block"
          [modelName$]="'content' | finToObservable"
          [name$]="'content' | finToObservable"
          [label$]="content().teaserText | finStripHtml | finToObservable"
          [group$]="contentForm() | finToObservable"
          [options$]="contentOptions() | finToObservable"
        />
      </div>
    </fin-form-fields>

    @if (selectedContent()) {
      <fin-cms-json-content [template$]="selectedContent() | finToObservable" />
    }
  </section>
}
